export default "__VITE_ASSET__BQfid53D__"